import axios from "../axios";
import {uuid} from 'vue-uuid';
import store from '../store/store'
import Vue from 'vue'

export const api = {

    /**
     * call api method
     * @param commit
     * @param method
     * @param path
     * @param payload
     * @param mutation
     * @param mock_data
     * @param content_type
     */
    call(commit, method, path, pl = false, mutation = false, mock_data = false, content_type = '') {

        // Unreact possible payload
        let payload = pl;

        //moduleSystem.actions.addAjaxRequests(moduleSystem.state, 1);
        store.dispatch("system/addAjaxRequests", 1);

        // Init config
        const config = {
            //withCredentials: true,
            headers: {}
        };

        // Add content type
        if (content_type) {
            config.headers['Content-Type'] = content_type;
        } else {
            payload = pl ? api.unreact(pl) : pl;
        }

        if (window.Echo && window.Echo.socketId()) config.headers['X-Socket-ID'] = window.Echo.socketId();

        // Create new promise
        return new Promise((resolve, reject) => {
            let promise = null;
            switch (method) {
                case 'get':
                    promise = axios.get(path, config);
                    break;
                case 'post':
                    promise = axios.post(path, payload, config);
                    break;
                case 'patch':
                    promise = axios.patch(path, payload, config);
                    break;
                case 'delete':
                    promise = axios.delete(path, config);
                    break;
            }
            // bad method
            if (!promise) throw 'Unknown REST method: ' + method;

            // resolve api call
            promise.then(res => {

                // Decrease requests count
                store.dispatch("system/addAjaxRequests", -1);

                // Get response data
                let resData = res.data.data ? res.data.data : res.data;

                // Resolve data
                if (res.data.status && res.data.status == 'error') {

                    // Process error
                    reject(res.data);
                } else {
                    // Apply esuresponse
                    //let resData = payload ? Object.assign(payload, respData) : respData;
                    if (mutation) commit(mutation, resData ? resData : payload);
                    // Resolve it
                    resolve(resData);
                }

            }).catch(err => {

                // Decrease requests count
                store.dispatch("system/addAjaxRequests", -1);

                // Show error
                console.log(err);

                // return mocked data on missing api method
                if (err.response.status === 405) {
                    if (mock_data && mutation) commit(mutation, mock_data);
                    resolve(mock_data);
                } else {
                    reject(err);
                }
            })
        });
    },


    /**
     * Send callback
     * @param commit
     * @param method
     * @param path
     * @param pl
     * @param mutation
     * @param mock_data
     * @returns {Promise<unknown>}
     */
    callPB(commit, method, path, pl, mutation, mock_data) {

        // Convert to base64
        let payload = btoa(pl);

        //moduleSystem.actions.addAjaxRequests(moduleSystem.state, 1);
        store.dispatch("system/addAjaxRequests", 1);

        // Init obj
        let config = {};

        // Create new promise
        return new Promise((resolve, reject) => {
            let promise = null;
            switch (method) {
                case 'get':
                    promise = axios.get(path);
                    break;
                case 'post':
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Content-Length': payload.length
                        }
                    };
                    promise = axios.post(path, payload, config);
                    break;
                case 'patch':
                    promise = axios.patch(path, payload);
                    break;
                case 'delete':
                    promise = axios.delete(path);
                    break;
            }
            // bad method
            if (!promise) throw 'Unknown REST method: ' + method;

            // resolve api call
            promise.then(res => {

                // Decrease requests count
                store.dispatch("system/addAjaxRequests", -1);

                // Get response data
                let resData = res.data.data ? res.data.data : res.data;

                // Resolve data
                if (res.data.status && res.data.status == 'error') {

                    // Process error
                    reject(res.data);
                } else {
                    // Apply esuresponse
                    //let resData = payload ? Object.assign(payload, respData) : respData;
                    if (mutation) commit(mutation, resData ? resData : payload);

                    // Resolve it
                    resolve(resData);
                }

            }).catch(err => {

                // Decrease requests count
                store.dispatch("system/addAjaxRequests", -1);

                // Show error
                console.log(err);

                // return mocked data on missing api method
                if (err.response.status === 404 || err.response.status === 405) {
                    if (mock_data && mutation) commit(mutation, mock_data);
                    resolve(mock_data);
                } else {
                    reject(err);
                }
            })
        });
    },

    /**
     * Send event to parents
     * @param event
     * @param data
     */
    emitParents(node, event, data) {
        // Send event to all parents
        while (node) {
            node.$emit(event, data);
            node = node.$parent
        }
    },

    /**
     * Create not reactive copy of object
     * @param data
     * @returns {any}
     */
    unreact(data) {

        // Return empty object
        if (!data) return false;

        // Unreact object
        return JSON.parse(JSON.stringify(data));
    },

    /**
     * Create reactive copy of object
     * @param data
     * @returns {any}
     */
    reactObject(obj) {

        // Register in vm
        var tmpVm = new Vue({data: {obj}});

        // Return object
        return tmpVm.obj;
    },

    /**
     * Generate uid
     * @returns {never|*}
     */
    uuid() {
        // Calc value
        let val = uuid.v1();

        // Return uid
        return val;
    },

    /**
     * Clean last segment of task
     * @param task
     */
    clearInstance(task) {
        // Check for array to process
        if (Array.isArray(task)) {
            // Init array
            let res = [];

            // Process each task
            for (let i of task) {
                // Patch items
                res.push(i.toString().replace(/\/(.+)/, ""));
            }

            // Return results
            return res;
        }

        // Just clearing
        return task.toString().replace(/\/(.+)/, "");
    },

    /**
     * Clean task
     * @param task
     */
    clearTask(task) {
        // Check for array to process
        if (Array.isArray(task)) {
            // Init array
            let res = [];

            // Process each task
            for (let i of task) {
                // Patch items
                res.push(i.toString().replace(/(.+)\//, ""));
            }

            // Return results
            return res;
        }

        // Just clearing
        return task.toString().replace(/(.+)\//, "");
    },

    /**
     * Clean task instance
     * @param task
     */
    cleanTaskInstances(fields, origData) {
        // Create a copy
        let data = this.unreact(origData);

        // Process array to clean instances
        for (let fl of fields) {
            data[fl] = this.clearInstance(data[fl]);
        }

        // Clean task
        return data;
    },

    /**
     * Empty promise
     */
    emptyPromise() {
        new Promise((resolve) => {
            resolve(null);
        })
    },

    /**
     * Wait for condition
     * @param func
     */
    waitAjaxFinishedCondition(func) {

        // Timeout
        setTimeout(() => {

            // Check for condition
            if (store.getters['system/getAjaxRequestsCount'] == 0) {
                func();
            } else {
                // Wait for condition if condition is not true
                this.waitAjaxFinishedCondition(func);
            }
        }, 300);
    },

    /**
     * Merge objects
     * @param o1
     * @param o2
     */
    mergeObjects(orig, nw) {
        // Init new object if empty
        if (!orig) orig = {};

        // Process each value
        for (let ind in nw) {
            // Apply new data to the original object
            if (nw[ind] !== undefined && nw[ind] !== null) Vue.set(orig, ind, nw[ind]);
        }

        // Return original
        return orig;
    },

    /**
     * Convert mysql time to unixtime
     * @param tm
     * @returns {number}
     */
    msTime2Unix(tm) {
        // Parse time
        var t = tm.split(/[- :]/);

        // Apply each element to the Date function
        var d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));

        // Return unix time
        return d.getTime() / 1000;
    },


    /**
     * Convert javascript to unixtime
     * @param tm
     * @returns {number}
     */
    unixtime(tm) {
        // Return unix time
        return tm / 1000;
    },

    /**
     * Converter
     * @param u8Array
     * @returns {string}
     */
    convertUint8ArrayToBinaryString(u8Array) {
        var i, len = u8Array.length, b_str = "";
        for (i = 0; i < len; i++) {
            b_str += String.fromCharCode(u8Array[i]);
        }
        return b_str;
    },

    /**
     * Activate links in text
     * @param inputText
     * @returns {*}
     */
    linkify(inputText) {
        let replacedText, replacePattern1, replacePattern2, replacePattern3;

        if (inputText.indexOf('<rawhtml/>') !== -1 || inputText.indexOf('<a') !== -1) return inputText;

        //URLs starting with http://, https://, or ftp://
        // eslint-disable-next-line no-useless-escape
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_()|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        // eslint-disable-next-line no-useless-escape
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        // eslint-disable-next-line no-useless-escape
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

        return replacedText;
    },

    /**
     * Get date and time format
     * @param ms
     */
    dateTime(ms) {
        let a = new Date(ms);
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let year = a.getFullYear();
        let month = months[a.getMonth()];
        let date = a.getDate();
        let hour = a.getHours();
        let min = a.getMinutes();
        let sec = a.getSeconds();
        let time = date + ' ' + month + ' ' + year + (hour || min || sec ? (' ' + hour + ':' + min + ':' + sec) : "");
        return time;
    },


    /**
     * Get date and time format
     * @param ms
     */

    resetToDate(ms) {
        let a = new Date(1000 * ms);
        let year = a.getFullYear();
        let month = a.getMonth();
        let date = a.getDate();
        return parseInt((new Date(year, month, date)).getTime() / 1000);
    },

    /**
     * Get unixtime
     */
    getUnixTime() {
        return (new Date()).getTime() / 1000;
    },

    /**
     * Get date and time format
     * @param ms
     */
    time(ms) {
        let a = new Date(ms);
        let hour = a.getHours();
        let min = a.getMinutes();
        let sec = a.getSeconds();
        let time = hour + ':' + min + ':' + sec;
        return time;
    },

    /**
     * Get date format
     * @param ms
     */
    date(ms) {
        let a = new Date(ms);
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let year = a.getFullYear();
        let month = months[a.getMonth()];
        let date = a.getDate();
        return date + ' ' + month + ' ' + year;
    },


    /**
     * Get time from seconds
     * @param tm
     * @param optimized
     */
    getTimeFromSeconds(tm, optimized = true) {

        // Time has hour part
        const hHour = tm / 3600 > 1;

        // Return full time string
        return tm ? ((hHour || !optimized ? (this.tsnumpad(parseInt(tm / 3600), 2) + ":") : "") + this.tsnumpad(parseInt(tm / 60) % 60, 2) + (!hHour || !optimized ? (":" + this.tsnumpad(parseInt(tm % 60), 2)) : "")) : "00:00";
    },

    /**
     * Get hours from seconds
     * @param tm
     * @param optimized
     */
    getHoursFromSeconds(tm) {

        // Time has hour part
        return (tm / 3600).toFixed(2);
    },

    /**
     * Get time from seconds
     * @param secc
     */
    getSecondsFromTime(sec) {

        // Split by ":"
        let parts = sec.split(":");

        // Return numeric
        return parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
    },


    /**
     * Numbers firmating
     * @param num
     * @param size
     * @returns {string}
     */
    tsnumpad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    },

    /**
     * Play sound
     */
    play(sound) {
        let audio = new Audio(sound);
        audio.play();
    },

    /**
     * Converts list to id value array
     */
    obj2idval(list, lblFn, idFn) {
        let mp = [];
        for (let i in list) {
            mp.push({
                id: (idFn ? idFn(list[i]) :  i),
                title: (lblFn ? lblFn(list[i]) : list[i])
            });
        }

        // Return value
        return mp;
    },

    /**
     * Check if object empty
     * @param obj
     */
    isEmptyObject(obj) {
        return !Object.values(obj).length;
    },

    /**
     * Check for changes
     * @param newVal
     * @param oldVal
     * @param fields
     */
    isChanged(newVal, oldVal, fields) {

        // Compare fields
        for (const fld of fields) {
            if (newVal[fld] !== undefined && newVal[fld] !== oldVal[fld]) return true;
        }

        // Nothing changed
        return false;
    },

    /**
     * Pluck field
     * @param list
     * @param fld
     */
    pluck(list, fld) {
        // Return data
        return Object.values(list).map((d) => d[fld])
    },

    /**
     * Check for mobile resolution
     * @returns {RegExpMatchArray}
     */
    isMobile() {

        // Mobile window
        return window.outerWidth <= 1000;

    },

    /**
     * Convert table to csv
     * @param table_id
     * @param separator
     */
    download_table_as_csv(table_class_name, separator = ',') {
        // Select rows from table_id
        var rows = document.querySelectorAll('table.' + table_class_name + ' tr');
        // Construct csv
        var csv = [];
        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll('td, th');
            for (var j = 0; j < cols.length; j++) {
                // Clean innertext to remove multiple spaces and jumpline (break csv)
                var data = cols[j].innerText.replace(/(\r\n|\n|\r)/gm, '').replace(/(\s\s)/gm, ' ')
                // Escape double-quote with double-double-quote (see https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv)
                data = data.replace(/"/g, '""');
                // Push escaped string
                row.push('"' + data + '"');
            }
            csv.push(row.join(separator));
        }
        var csv_string = csv.join('\n');
        // Download it
        var filename = 'export_' + table_class_name + '_' + new Date().toLocaleDateString() + '.csv';
        var link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('target', '_blank');
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string));
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    getAvatarUrl(avatar) {
        return process.env.VUE_APP_USER_AVATAR_URL + avatar
    }



};
